import { render, staticRenderFns } from "./list_vip.vue?vue&type=template&id=1dd33927"
import script from "./list_vip.vue?vue&type=script&lang=js"
export * from "./list_vip.vue?vue&type=script&lang=js"
import style0 from "./list_vip.vue?vue&type=style&index=0&id=1dd33927&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports